export default "/fonts/vendor/@fontsource/space-mono/files/space-mono-all-700-normal.woff?63ae6157a62abe78441afa6d680660a4";